import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';

const ConfirmDeleteModal = ({ isOpen, project, onConfirm, onCancel }) => {
    const handleConfirm = () => {
        onConfirm(project.id);
    };

    return (
        <Dialog
            open={isOpen}
            onClose={onCancel}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2,
                }
            }}
        >
            <DialogTitle component="div" sx={{ pb: 1 }}>
                <Typography variant="h6" fontWeight="600">
                    Elimina progetto
                </Typography>
            </DialogTitle>

            <DialogContent sx={{ pt: 1, pb: 2 }}>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Eliminare "{project.titolo || project.description}"?
                </Typography>

                <Typography variant="body2" color="text.secondary">
                    Questa azione non può essere annullata.
                </Typography>
            </DialogContent>

            <DialogActions sx={{ p: 2, gap: 1 }}>
                <Button
                    onClick={onCancel}
                    variant="outlined"
                    color="inherit"
                    sx={{ minWidth: 100 }}
                >
                    Annulla
                </Button>
                <Button
                    startIcon={<DeleteIcon />}
                    onClick={handleConfirm}
                    variant="contained"
                    color="error"
                    sx={{ minWidth: 100 }}
                >
                    Elimina
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteModal;